module.exports = __webpack_public_path__ + "static/img/5.0ce8885.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/4/zh/5.png
// module id = lYjr
// module chunks = 0